import React, { Component } from 'react';
import { Field } from 'formik';
import moment from 'moment';

import ButtonDeprecated, { BUTTON_THEME_BLUE } from 'client/components/ButtonDeprecated';

import { SR_API_ACTION_ADMIN_OVERRIDE_LISTING_DATA } from 'api/actionTypes';

import withApiState from 'client/helpers/withApiState';

@withApiState(({ formItem }) => {
  return {
    requestUpdateOverridesApiState: {
      action: SR_API_ACTION_ADMIN_OVERRIDE_LISTING_DATA,
      queryId: `update-${formItem.name}`,
    },
    requestRemoveOverrideApiState: {
      action: SR_API_ACTION_ADMIN_OVERRIDE_LISTING_DATA,
      queryId: `remove-${formItem.name}`,
    },
  };
})
class SrAdminEditListingFormField extends Component {
  _onUpdate = () => {
    const { onUpdate, formItem, newValue } = this.props;
    const value = ['array', 'json'].includes(formItem.type)
      ? JSON.parse(newValue)
      : newValue;

    onUpdate(formItem.name, value);
  };

  _onRemoveOverride = () => {
    const { onRemoveOverride, formItem } = this.props;
    onRemoveOverride(formItem.name);
  };

  render() {
    const {
      formItem,
      newValue,
      currentValue,
      isOverriden,
      errorMessage,
      requestUpdateOverridesApiState,
      requestRemoveOverrideApiState,
    } = this.props;
    const buttonDisabled = newValue === currentValue || requestUpdateOverridesApiState.inProgress;

    let fieldDOM = null;
    switch (formItem.type) {
      case 'text':
        fieldDOM = <Field name={formItem.name} type='text' />;
        break;
      case 'long_text':
        fieldDOM = <Field name={formItem.name} style={{ height: 150 }} component='textarea' />;
        break;
      case 'number':
        fieldDOM = <Field name={formItem.name} type='number' />;
        break;
      case 'array':
      case 'json':
        fieldDOM = (
          <Field
            name={formItem.name}
            component='textarea'
            style={{ height: 150 }}
            validate={(value) => {
              try {
                JSON.parse(value);
              }
              catch (err) {
                return `Invalid ${formItem.type}`;
              }
            }}
          />
        );
        break;
      case 'select':
        fieldDOM = (
          <Field component='select' name={formItem.name}>
            {formItem.optionItems.map((optionItem) => (
              <option key={`${optionItem.value}`} value={optionItem.value}>
                {optionItem.label}
              </option>
            ))}
          </Field>
        );
        break;
      case 'date':
        fieldDOM = (
          <Field
            name={formItem.name}
            type='text'
            validate={(value) => {
              const date = moment(value);
              if (!date.isValid()) {
                return 'Invalid date';
              }
            }}
          />
        );
        break;
    }

    return (
      <div style={{ marginTop: 20 }}>
        <div>
          <span className='headline'>{formItem.label}</span>
        </div>
        <div className='value'>
          {fieldDOM}
        </div>
        {errorMessage && (
          <div style={{ color: 'red' }}>{errorMessage}</div>
        )}
        <ButtonDeprecated
          theme={BUTTON_THEME_BLUE}
          type='button'
          onClick={this._onUpdate}
          disabled={buttonDisabled}
        >
          {requestUpdateOverridesApiState.inProgress ? 'updating...' : 'save'}
        </ButtonDeprecated>
        {isOverriden && (
          <ButtonDeprecated
            theme={BUTTON_THEME_BLUE}
            type='button'
            onClick={this._onRemoveOverride}
            disabled={requestRemoveOverrideApiState.inProgress}
          >
            {requestRemoveOverrideApiState.inProgress ? 'removing...' : 'remove'} override
          </ButtonDeprecated>
        )}
      </div>
    );
  }
}

SrAdminEditListingFormField.displayName = 'SrAdminEditListingFormField';

export default SrAdminEditListingFormField;
